// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { ThemeMode } from 'types/config';

// assets
import logo from 'assets/images/logo/logo-v1.png';
import logoDark from 'assets/images/logo/logo-v1-light.png';

// ==============================|| LOGO ||============================== //

const LogoMain = ({ reverse, ...others }: { reverse?: boolean }) => {
  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      {/* <svg width="66" height="28" viewBox="0 0 66 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M52.7694 1.05138V7H51.6023V0.0922266H52.6774L52.7694 1.05138ZM56.1835 2.54084V2.63768C56.1835 3.00044 56.1383 3.33707 56.0479 3.64756C55.9608 3.95498 55.83 4.22398 55.6557 4.45455C55.4846 4.68204 55.2731 4.85881 55.0213 4.98485C54.7695 5.11089 54.4789 5.17391 54.1496 5.17391C53.8235 5.17391 53.5378 5.11704 53.2924 5.00329C53.0503 4.88647 52.8453 4.722 52.6774 4.50988C52.5095 4.29776 52.3739 4.04875 52.2706 3.76285C52.1705 3.47387 52.0995 3.15722 52.0575 2.81291V2.43939C52.0995 2.07356 52.1705 1.74155 52.2706 1.44335C52.3739 1.14515 52.5095 0.88845 52.6774 0.673254C52.8453 0.458059 53.0503 0.292051 53.2924 0.175231C53.5346 0.0584102 53.817 0 54.1399 0C54.4692 0 54.7614 0.0614844 55.0164 0.184453C55.2715 0.304348 55.4862 0.476504 55.6605 0.700922C55.8349 0.922266 55.9656 1.18972 56.0528 1.50329C56.14 1.81379 56.1835 2.15964 56.1835 2.54084ZM55.0164 2.63768V2.54084C55.0164 2.31028 54.9938 2.09662 54.9486 1.89987C54.9034 1.70004 54.8324 1.52481 54.7356 1.37418C54.6387 1.22354 54.5144 1.10672 54.3627 1.02372C54.2142 0.937637 54.035 0.894598 53.8251 0.894598C53.6185 0.894598 53.4409 0.928415 53.2924 0.996047C53.1439 1.06061 53.0196 1.1513 52.9195 1.26812C52.8194 1.38494 52.742 1.52174 52.6871 1.67852C52.6322 1.83224 52.5934 1.99978 52.5708 2.18116V3.07576C52.6096 3.2971 52.6758 3.5 52.7694 3.68445C52.863 3.86891 52.9954 4.01647 53.1665 4.12714C53.3408 4.23474 53.5636 4.28854 53.8348 4.28854C54.0447 4.28854 54.2238 4.2455 54.3723 4.15942C54.5209 4.07334 54.6419 3.95498 54.7356 3.80435C54.8324 3.65064 54.9034 3.47387 54.9486 3.27404C54.9938 3.07422 55.0164 2.8621 55.0164 2.63768Z"
          fill={theme.palette.primary.main}
        />
        <path
          d="M58.5466 1.04216V5.08169H57.3795V0.0922266H58.4933L58.5466 1.04216ZM60.1496 0.0599473L60.1399 1.09289C60.0688 1.08059 59.9914 1.07137 59.9074 1.06522C59.8267 1.05907 59.746 1.05599 59.6653 1.05599C59.4651 1.05599 59.2892 1.08366 59.1374 1.139C58.9857 1.19126 58.8582 1.26812 58.7548 1.36957C58.6548 1.46794 58.5773 1.58783 58.5224 1.72925C58.4675 1.87066 58.4352 2.02899 58.4255 2.20422L58.1592 2.22266C58.1592 1.90909 58.1915 1.61858 58.256 1.35112C58.3206 1.08366 58.4175 0.848485 58.5466 0.645586C58.679 0.442688 58.8436 0.284365 59.0406 0.170619C59.2407 0.0568731 59.4716 0 59.7331 0C59.8041 0 59.88 0.00614844 59.9607 0.0184453C60.0446 0.0307422 60.1076 0.0445762 60.1496 0.0599473Z"
          fill={theme.palette.primary.main}
        />
        <path
          d="M60.7305 2.64229V2.53623C60.7305 2.17655 60.7854 1.843 60.8951 1.53557C61.0049 1.22508 61.1631 0.956083 61.3697 0.72859C61.5796 0.498024 61.8346 0.319719 62.1349 0.193676C62.4384 0.0645586 62.7806 0 63.1615 0C63.5457 0 63.888 0.0645586 64.1882 0.193676C64.4917 0.319719 64.7484 0.498024 64.9582 0.72859C65.1681 0.956083 65.3279 1.22508 65.4376 1.53557C65.5474 1.843 65.6023 2.17655 65.6023 2.53623V2.64229C65.6023 3.00198 65.5474 3.33553 65.4376 3.64295C65.3279 3.95037 65.1681 4.21937 64.9582 4.44993C64.7484 4.67743 64.4933 4.85573 64.1931 4.98485C63.8928 5.11089 63.5522 5.17391 63.1712 5.17391C62.787 5.17391 62.4432 5.11089 62.1397 4.98485C61.8395 4.85573 61.5844 4.67743 61.3746 4.44993C61.1647 4.21937 61.0049 3.95037 60.8951 3.64295C60.7854 3.33553 60.7305 3.00198 60.7305 2.64229ZM61.8976 2.53623V2.64229C61.8976 2.86671 61.9218 3.07883 61.9702 3.27866C62.0187 3.47848 62.0945 3.65371 62.1978 3.80435C62.3012 3.95498 62.4335 4.07334 62.5949 4.15942C62.7564 4.2455 62.9485 4.28854 63.1712 4.28854C63.3875 4.28854 63.5748 4.2455 63.733 4.15942C63.8944 4.07334 64.0268 3.95498 64.1301 3.80435C64.2334 3.65371 64.3093 3.47848 64.3577 3.27866C64.4094 3.07883 64.4352 2.86671 64.4352 2.64229V2.53623C64.4352 2.31489 64.4094 2.10584 64.3577 1.90909C64.3093 1.70927 64.2318 1.5325 64.1253 1.37879C64.0219 1.22508 63.8896 1.10518 63.7282 1.0191C63.57 0.929952 63.3811 0.885375 63.1615 0.885375C62.942 0.885375 62.7515 0.929952 62.5901 1.0191C62.4319 1.10518 62.3012 1.22508 62.1978 1.37879C62.0945 1.5325 62.0187 1.70927 61.9702 1.90909C61.9218 2.10584 61.8976 2.31489 61.8976 2.53623Z"
          fill={theme.palette.primary.main}
        />
        <path
          d="M13.524 24.248H6.188L5.012 27.72H0L7.112 8.064H12.656L19.768 27.72H14.7L13.524 24.248ZM12.292 20.552L9.856 13.356L7.448 20.552H12.292Z"
          fill={theme.palette.primary.main}
        />
        <path
          d="M27.2805 14.308C27.7285 13.58 28.3725 12.992 29.2125 12.544C30.0525 12.096 31.0139 11.872 32.0965 11.872C33.3845 11.872 34.5512 12.1987 35.5965 12.852C36.6419 13.5053 37.4632 14.4387 38.0605 15.652C38.6765 16.8653 38.9845 18.2747 38.9845 19.88C38.9845 21.4853 38.6765 22.904 38.0605 24.136C37.4632 25.3493 36.6419 26.292 35.5965 26.964C34.5512 27.6173 33.3845 27.944 32.0965 27.944C30.9952 27.944 30.0339 27.7293 29.2125 27.3C28.3912 26.852 27.7472 26.264 27.2805 25.536V27.72H22.4925V7H27.2805V14.308ZM34.1125 19.88C34.1125 18.6853 33.7765 17.752 33.1045 17.08C32.4512 16.3893 31.6392 16.044 30.6685 16.044C29.7165 16.044 28.9045 16.3893 28.2325 17.08C27.5792 17.7707 27.2525 18.7133 27.2525 19.908C27.2525 21.1027 27.5792 22.0453 28.2325 22.736C28.9045 23.4267 29.7165 23.772 30.6685 23.772C31.6205 23.772 32.4325 23.4267 33.1045 22.736C33.7765 22.0267 34.1125 21.0747 34.1125 19.88Z"
          fill={theme.palette.primary.main}
        />
        <path d="M46.8444 7V27.72H42.0564V7H46.8444Z" fill={theme.palette.primary.main} />
        <path
          d="M65.6022 19.656C65.6022 20.104 65.5742 20.5707 65.5182 21.056H54.6822C54.7569 22.0267 55.0649 22.7733 55.6062 23.296C56.1662 23.8 56.8476 24.052 57.6502 24.052C58.8449 24.052 59.6756 23.548 60.1423 22.54H65.2383C64.9769 23.5667 64.5009 24.4907 63.8103 25.312C63.1383 26.1333 62.2889 26.7773 61.2622 27.244C60.2356 27.7107 59.0876 27.944 57.8182 27.944C56.2876 27.944 54.9249 27.6173 53.7302 26.964C52.5356 26.3107 51.6022 25.3773 50.9302 24.164C50.2582 22.9507 49.9222 21.532 49.9222 19.908C49.9222 18.284 50.2489 16.8653 50.9022 15.652C51.5742 14.4387 52.5076 13.5053 53.7022 12.852C54.8969 12.1987 56.2689 11.872 57.8182 11.872C59.3302 11.872 60.6743 12.1893 61.8503 12.824C63.0262 13.4587 63.9409 14.364 64.5943 15.54C65.2663 16.716 65.6022 18.088 65.6022 19.656ZM60.7022 18.396C60.7022 17.5747 60.4222 16.9213 59.8622 16.436C59.3022 15.9507 58.6022 15.708 57.7622 15.708C56.9596 15.708 56.2783 15.9413 55.7183 16.408C55.1769 16.8747 54.8409 17.5373 54.7102 18.396H60.7022Z"
          fill={theme.palette.primary.main}
        />
      </svg> */}

      {matchDownMd ? (
        <img src={theme.palette.mode === ThemeMode.DARK ? logoDark : logo} alt="icon logo" height={40} />
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0.00 0.00 1920.00 720.00" height={40}>
          <defs>
            <linearGradient id="gradient" x1="0.07" y1="0.25" x2="0.93" y2="0.75">
              <stop offset="20%" stopColor="#673dfe" />
              <stop offset="80%" stopColor="#cb449a" />
            </linearGradient>
          </defs>
          <g id="habihub">
            <g id="habi">
              <path
                id="h"
                fill={theme.palette.mode === ThemeMode.DARK ? '#F3F3F3' : '#242424'}
                d="
              M 105.67 336.40
              Q 113.45 330.54 119.70 327.22
              Q 141.31 315.74 164.85 312.76
              C 175.16 311.45 187.51 311.82 198.16 313.80
              Q 217.43 317.37 235.72 326.94
              Q 243.74 331.13 250.48 336.59
              A 0.29 0.29 0.0 0 0 250.95 336.36
              Q 251.11 275.56 250.94 208.06
              C 250.92 198.18 253.14 191.22 261.26 185.34
              Q 268.68 179.97 279.01 181.41
              C 285.84 182.37 290.99 186.66 294.98 191.99
              C 296.64 194.22 298.01 197.01 298.01 199.82
              Q 297.98 311.87 298.02 423.29
              C 298.02 424.95 297.72 426.50 297.72 428.25
              Q 297.81 472.74 297.71 517.25
              C 297.68 532.46 283.67 543.35 269.15 540.47
              C 259.69 538.59 252.57 532.33 250.59 523.19
              Q 249.68 518.97 249.70 513.35
              Q 249.87 474.02 249.77 432.63
              Q 249.74 421.52 246.78 411.76
              Q 237.99 382.82 211.55 368.63
              Q 197.78 361.24 182.27 360.14
              C 162.87 358.77 142.56 366.74 128.75 379.80
              Q 111.64 395.99 107.27 420.30
              Q 106.04 427.19 106.13 440.28
              Q 106.38 477.58 106.15 517.57
              Q 106.11 525.60 100.89 532.44
              C 95.72 539.21 85.65 542.10 77.32 540.42
              C 65.35 538.01 57.96 527.46 57.96 515.43
              Q 58.04 365.51 57.99 205.50
              Q 57.99 191.75 69.65 184.43
              C 76.48 180.14 87.57 179.69 94.58 184.71
              C 99.05 187.91 104.99 193.91 104.99 199.84
              Q 105.01 268.57 104.99 336.06
              Q 104.99 336.91 105.67 336.40
              Z"
              />

              <path
                id="a"
                fill={theme.palette.mode === ThemeMode.DARK ? '#F3F3F3' : '#242424'}
                d="
              M 957.40 539.74
              C 950.98 540.56 942.63 538.36 937.84 533.55
              Q 930.59 526.27 930.59 515.85
              Q 930.57 428.35 930.58 325.09
              Q 930.58 313.43 938.00 306.61
              Q 945.31 299.90 955.10 300.07
              Q 964.96 300.24 972.01 307.88
              C 977.71 314.06 978.65 319.50 978.64 327.46
              Q 978.51 420.04 978.60 515.08
              C 978.61 527.87 970.26 538.12 957.40 539.74
              Z"
              />

              <path
                id="b"
                fill={theme.palette.mode === ThemeMode.DARK ? '#F3F3F3' : '#242424'}
                d="
              M 692.98 323.58
              A 0.22 0.21 -17.9 0 0 693.32 323.75
              Q 712.54 310.45 734.69 304.18
              C 750.86 299.59 770.12 298.65 787.11 302.17
              Q 807.33 306.37 823.31 315.18
              Q 854.30 332.27 870.58 363.31
              C 875.35 372.42 879.61 383.15 881.90 393.25
              C 887.30 417.03 885.48 442.36 876.08 465.11
              Q 857.37 510.43 811.68 530.84
              C 802.74 534.83 791.44 537.80 781.52 538.96
              Q 762.97 541.11 746.00 538.51
              C 726.99 535.58 708.72 527.22 693.46 516.21
              A 0.33 0.33 0.0 0 0 692.93 516.47
              Q 692.73 526.42 685.29 533.57
              C 677.62 540.93 665.78 541.75 656.38 536.61
              C 649.17 532.67 645.05 524.32 645.04 516.14
              Q 644.96 361.28 645.03 204.98
              Q 645.03 192.30 653.98 185.29
              Q 659.26 181.15 665.15 180.36
              C 674.09 179.16 681.01 181.87 686.90 188.47
              Q 692.93 195.23 692.94 203.10
              Q 693.06 264.64 692.98 323.58
              Z
              M 836.91 420.02
              A 71.93 71.93 0.0 0 0 764.98 348.09
              A 71.93 71.93 0.0 0 0 693.05 420.02
              A 71.93 71.93 0.0 0 0 764.98 491.95
              A 71.93 71.93 0.0 0 0 836.91 420.02
              Z"
              />

              <g id="i" fill={theme.palette.mode === ThemeMode.DARK ? '#F3F3F3' : '#242424'}>
                <circle cx="954.59" cy="230.39" r="26.36" />

                <path
                  d="
                M 544.16 515.91
                A 0.21 0.21 0.0 0 0 543.83 515.75
                Q 506.76 542.79 460.86 538.95
                Q 448.13 537.88 434.89 533.88
                Q 425.56 531.07 416.44 526.09
                Q 383.86 508.31 366.04 475.91
                Q 361.21 467.12 358.14 457.58
                C 349.54 430.86 350.20 399.57 361.20 373.56
                C 370.16 352.38 384.98 333.46 404.07 320.58
                Q 435.65 299.28 474.07 299.55
                C 497.62 299.71 521.30 307.80 540.65 320.91
                C 563.03 336.06 578.49 358.59 586.66 384.02
                Q 592.19 401.24 592.21 421.95
                Q 592.23 468.12 592.21 514.89
                Q 592.21 528.31 581.74 535.78
                C 574.47 540.97 564.00 541.17 556.10 536.86
                Q 544.84 530.72 544.16 515.91
                Z
                M 544.08 419.54
                A 71.90 71.90 0.0 0 0 472.18 347.64
                A 71.90 71.90 0.0 0 0 400.28 419.54
                A 71.90 71.90 0.0 0 0 472.18 491.44
                A 71.90 71.90 0.0 0 0 544.08 419.54
                Z"
                />
              </g>
            </g>

            <g id="hub">
              <g id="h-top" fill={theme.palette.mode === ThemeMode.DARK ? '#F3F3F3' : '#242424'}>
                <path
                  d="
                M 1094.81 327.58
                Q 1105.17 342.81 1119.43 349.83
                Q 1126.94 353.53 1133.53 356.42
                Q 1141.29 359.83 1150.94 359.86
                Q 1155.21 359.88 1159.56 360.26
                Q 1169.77 361.16 1179.53 364.58
                Q 1188.70 368.42 1194.69 372.82
                Q 1204.36 379.92 1213.07 391.39
                Q 1190.42 403.55 1167.00 406.32
                Q 1159.86 407.17 1150.67 407.02
                Q 1142.06 406.89 1134.43 405.48
                Q 1113.58 401.63 1094.82 391.44
                Q 1091.17 389.08 1087.54 386.68
                Q 1070.84 375.63 1058.47 359.59
                C 1045.69 342.69 1037.07 320.92 1034.74 299.73
                Q 1033.92 292.28 1033.96 280.50
                Q 1034.08 243.28 1034.00 202.30
                C 1033.98 187.98 1045.91 176.84 1060.22 178.04
                C 1070.62 178.92 1078.92 185.28 1081.46 195.31
                Q 1082.31 198.66 1082.31 207.27
                Q 1082.30 246.26 1082.37 286.25
                Q 1082.40 304.14 1090.60 319.97
                Q 1092.57 323.76 1094.81 327.58
                Z"
                />

                <path
                  d="
                M 1249.71 359.12
                Q 1235.19 340.22 1213.23 328.20
                Q 1213.68 327.32 1213.92 326.75
                Q 1214.22 326.04 1214.64 325.34
                Q 1222.20 312.86 1224.66 299.32
                Q 1225.82 292.95 1225.81 281.26
                Q 1225.79 244.82 1225.71 207.03
                Q 1225.69 197.66 1227.33 193.25
                Q 1230.76 184.05 1239.33 180.33
                Q 1246.63 177.17 1253.90 178.44
                C 1263.01 180.04 1270.07 186.35 1272.68 194.86
                Q 1273.86 198.73 1273.84 205.95
                Q 1273.74 245.54 1273.78 286.96
                Q 1273.79 310.64 1264.07 333.59
                Q 1257.92 348.12 1249.71 359.12
                Z"
                />
              </g>

              <path
                id="h-bottom"
                fill="url(#gradient)"
                d="
              M 1191.15 318.26
              Q 1192.05 320.25 1191.12 322.05
              Q 1190.89 322.50 1190.89 323.00
              L 1190.89 325.07
              Q 1190.89 325.59 1190.48 325.90
              Q 1189.54 326.62 1189.92 327.98
              Q 1190.07 328.52 1189.61 328.82
              Q 1188.52 329.52 1188.90 331.07
              A 1.78 1.78 0.0 0 1 1188.76 332.28
              C 1188.42 332.94 1188.16 333.13 1187.99 333.92
              Q 1187.08 338.02 1185.86 342.07
              Q 1185.06 344.75 1184.67 347.45
              A 0.49 0.49 0.0 0 1 1184.53 347.74
              L 1184.23 348.03
              Q 1183.98 348.28 1183.95 348.64
              Q 1183.74 351.15 1182.95 353.78
              Q 1182.50 355.27 1182.10 356.89
              Q 1181.77 358.19 1181.30 359.48
              Q 1180.87 360.63 1180.65 362.12
              Q 1180.54 362.84 1179.53 364.58
              Q 1169.77 361.16 1159.56 360.26
              Q 1155.21 359.88 1150.94 359.86
              Q 1141.29 359.83 1133.53 356.42
              Q 1126.94 353.53 1119.43 349.83
              Q 1105.17 342.81 1094.81 327.58
              Q 1103.01 323.54 1107.27 321.76
              Q 1123.94 314.75 1140.76 312.78
              Q 1166.39 309.78 1191.15 318.26
              Z
               M 1058.47 359.59
              Q 1070.84 375.63 1087.54 386.68
              Q 1091.17 389.08 1094.82 391.44
              Q 1085.80 405.03 1083.20 420.56
              Q 1082.08 427.30 1082.14 439.00
              Q 1082.35 479.36 1082.15 517.43
              C 1082.14 520.90 1081.35 524.62 1079.82 527.68
              Q 1073.31 540.78 1057.98 540.81
              Q 1043.17 540.84 1036.07 526.26
              C 1034.64 523.33 1034.29 519.58 1034.28 516.27
              Q 1034.09 471.33 1034.33 432.17
              Q 1034.45 412.23 1039.30 397.75
              C 1044.02 383.69 1049.75 371.30 1058.47 359.59
              Z
               M 1191.15 318.26
              Q 1203.39 321.95 1213.23 328.20
              Q 1235.19 340.22 1249.71 359.12
              Q 1257.06 370.86 1259.10 374.65
              C 1266.11 387.68 1271.50 403.59 1272.99 419.16
              Q 1273.84 428.01 1273.81 438.73
              Q 1273.72 477.20 1273.79 516.38
              C 1273.82 532.13 1260.17 543.59 1244.82 540.41
              C 1235.62 538.50 1229.11 532.66 1226.73 523.75
              Q 1225.77 520.15 1225.75 513.38
              Q 1225.66 477.10 1225.82 438.23
              Q 1225.87 426.89 1224.75 420.31
              Q 1222.11 404.77 1213.07 391.39
              Q 1204.36 379.92 1194.69 372.82
              Q 1188.70 368.42 1179.53 364.58
              Q 1180.54 362.84 1180.65 362.12
              Q 1180.87 360.63 1181.30 359.48
              Q 1181.77 358.19 1182.10 356.89
              Q 1182.50 355.27 1182.95 353.78
              Q 1183.74 351.15 1183.95 348.64
              Q 1183.98 348.28 1184.23 348.03
              L 1184.53 347.74
              A 0.49 0.49 0.0 0 0 1184.67 347.45
              Q 1185.06 344.75 1185.86 342.07
              Q 1187.08 338.02 1187.99 333.92
              C 1188.16 333.13 1188.42 332.94 1188.76 332.28
              A 1.78 1.78 0.0 0 0 1188.90 331.07
              Q 1188.52 329.52 1189.61 328.82
              Q 1190.07 328.52 1189.92 327.98
              Q 1189.54 326.62 1190.48 325.90
              Q 1190.89 325.59 1190.89 325.07
              L 1190.89 323.00
              Q 1190.89 322.50 1191.12 322.05
              Q 1192.05 320.25 1191.15 318.26
              Z"
              />

              <path
                id="u"
                fill={theme.palette.mode === ThemeMode.DARK ? '#F3F3F3' : '#242424'}
                d="
              M 1518.69 516.44
              A 0.31 0.30 72.2 0 0 1518.21 516.19
              C 1501.33 528.23 1481.66 536.94 1460.83 539.10
              C 1437.15 541.55 1413.48 538.50 1392.57 527.55
              Q 1358.85 509.89 1340.29 476.11
              C 1331.07 459.34 1326.73 439.74 1326.65 420.84
              Q 1326.52 390.31 1326.59 324.83
              Q 1326.60 313.47 1334.03 306.58
              Q 1341.06 300.07 1350.77 300.06
              Q 1360.68 300.06 1367.94 307.80
              C 1373.16 313.37 1374.64 318.67 1374.62 326.24
              Q 1374.50 374.83 1374.63 420.36
              C 1374.69 441.89 1384.79 462.42 1401.07 475.76
              C 1417.77 489.45 1441.05 495.36 1462.19 490.20
              Q 1497.67 481.55 1512.79 448.19
              C 1517.75 437.24 1518.64 426.45 1518.61 413.37
              Q 1518.49 369.21 1518.61 324.23
              C 1518.67 302.25 1545.08 291.57 1560.08 307.96
              C 1565.81 314.22 1566.65 319.64 1566.64 327.74
              Q 1566.54 421.47 1566.58 515.62
              Q 1566.58 520.60 1565.04 524.33
              C 1559.22 538.44 1544.60 543.74 1530.93 537.10
              C 1523.18 533.33 1518.68 524.87 1518.69 516.44
              Z"
              />

              <path
                id="b"
                fill={theme.palette.mode === ThemeMode.DARK ? '#F3F3F3' : '#242424'}
                d="
              M 1668.07 323.52
              Q 1687.65 310.09 1709.72 304.00
              C 1725.65 299.60 1744.79 298.67 1761.59 302.17
              Q 1781.32 306.27 1797.11 314.86
              Q 1827.76 331.53 1844.10 361.68
              C 1849.17 371.03 1853.71 382.17 1856.13 392.51
              C 1861.66 416.18 1860.04 442.01 1850.66 464.76
              Q 1833.63 506.04 1794.45 526.82
              C 1771.75 538.86 1745.95 542.19 1720.94 538.57
              C 1701.69 535.78 1683.69 527.42 1667.87 516.28
              A 0.37 0.36 17.7 0 0 1667.29 516.57
              Q 1667.23 525.28 1661.00 532.26
              C 1653.68 540.46 1641.69 541.99 1631.75 537.11
              C 1623.62 533.12 1619.38 524.48 1619.39 515.54
              Q 1619.49 366.53 1619.34 215.37
              Q 1619.33 200.82 1620.34 197.04
              Q 1622.85 187.63 1633.22 182.26
              Q 1638.29 179.63 1645.80 180.21
              Q 1652.42 180.73 1657.38 184.77
              C 1664.36 190.45 1667.44 196.46 1667.42 205.22
              Q 1667.29 262.83 1667.45 323.19
              Q 1667.45 323.94 1668.07 323.52
              Z
              M 1811.31 420.02
              A 71.93 71.93 0.0 0 0 1739.38 348.09
              A 71.93 71.93 0.0 0 0 1667.45 420.02
              A 71.93 71.93 0.0 0 0 1739.38 491.95
              A 71.93 71.93 0.0 0 0 1811.31 420.02
              Z"
              />
            </g>
          </g>
        </svg>
      )}
    </>
  );
};

export default LogoMain;
